module.exports = __webpack_public_path__ + "static/img/image_5.018df43d.png";